import { Component } from 'react';

import { ActionTemporaryError } from '@kc-console/shared-ui';

import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    if (process.env.NODE_ENV === 'development') {
      console.error('[ErrorBoundary]', error);
      console.error('[ErrorBoundary] Component stack:', errorInfo.componentStack);
    }
  }

  public render() {
    if (this.state.hasError) {
      return <ActionTemporaryError />;
    }
    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
